import React, { useEffect, useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";
import TextInput from "common/TextInput";

const AskServerName = () => (
  <TextInput
    type="text"
    name="server"
    label="NTP server IP address:"
    className="input-control"
    placeholder="Ex: 192.168.1.1"
    icon="place"
  />
);

const Warning = () => (
  <p>
    {" "}
    <b>NOTE:</b> When adding the first NTP server, when the time is
    synchronized, if the synchronization implies a significant change in time,
    it may cause a disruption in traffic of around 10 seconds. In those cases,
    it is recommended to perform a software reload of the active bqn package in
    Administration-&gt;Software
  </p>
);
const InstallModal = () => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const actions = useContext(ActionsContext);

  const whenDone = () => actions.send("do-load");

  const doOpen = () => {
    setOpen(true);
  };
  const doClose = () => {
    setOpen(false);
  };
  const doApply = ({ server }) =>
    ifCl
      .run(`set service ntp server ${server}`)
      .then(whenDone)
      .then(doClose)
      .catch(setError);

  useEffect(() => actions.recv(`add-server`, () => doOpen()), []);
  return open !== true ? null : (
    <Modal
      title="Add NTP Server"
      superIcon="add_circle"
      onApply={doApply}
      onClose={doClose}
      closeLabel="CANCEL"
      content={() => (
        <>
          <AskServerName />
          <Warning />
        </>
      )}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};

export default InstallModal;
